<template>
<div>
  <div class="content content-boxed">
    <!-- Information du profile -->
    <div class="row">
      <h2 class="block-title align-center">{{sectionTitle[actualLanguage]}}</h2>

      <div v-if="flagDisplayNewGraph" class="col-xs-12">

        <div class="col-sm-12 col-lg-12">
          <div id="chart">
            <apexchart type="bar" height="400" :options="chartOptions" :series="chartDataSeries"></apexchart>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
</template>



<script>

import Vue from 'vue'
import {mapState, mapActions, mapGetters} from 'vuex'

//https://apexcharts.com/docs/vue-charts/
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)


export default {
  name: 'GraphApexTimeline',
  props: ['GraphData'],
 
  /* Structure of GraphData:
  GraphData = {
    ChartTitle : {FR:'Titre Francais',EN:'English title'},
    XData : ['Label 1','Label 2',...],
    YData : [{name: 'Series name',data: [Data 1, Data 2, ...]}]
    Options : {stacked:true/false}
  }
  */

  data() {
    return {
      actualLanguage : "FR",
      sectionTitle: this.GraphData.ChartTitle,
      flagDisplayNewGraph : true,


      chartDataSeries: this.GraphData.YData,

      chartOptions: {
         chart: {
          id: 'vuechart-example',
          stacked: this.GraphData.Options.Stacked,
          stackType: this.GraphData.Options.StackType
        },
        xaxis: {
          categories: this.GraphData.XData,
        }
      },
    }
  },

  components: {

  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData','actualBundle','parentContainer']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

  },

  mounted() {

    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }
}
</script>





// WEBPACK FOOTER //
// GraphApexBars.vue?360d75d6